export const TOKEN_TTL_REFRESH_WINDOW_SECONDS = 30 * 24 * 60 * 60;

export function isDeviceTokenTtlRefreshDue(
  tokenTtlUnixSeconds: number,
  nowUnixSeconds: number = Math.floor(Date.now() / 1000),
  refreshWindowSeconds: number = TOKEN_TTL_REFRESH_WINDOW_SECONDS,
): boolean {
  return tokenTtlUnixSeconds - nowUnixSeconds <= refreshWindowSeconds;
}
